<template>
    <div>
        <div class="d-flex flex-column gap-2 ans-q-container " v-for="(question,idx) in this.template.freeText"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div class="q-content">{{question['content']}}</div>
            <div>
                <div v-for="(a,index) in question.answers">
                    <div class="m-c-answer-container d-flex flex-column gap-2">
                        <div>Answer</div>
                        <textarea id="a-1" type="text" placeholder="Enter Answer" class="q-input ans-content"
                                  autocomplete="off"
                                  @input="changeHandler($event, idx, index)"
                                  v-model="a.value">
                    </textarea>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'freeText-component',
        data() {
            return {}
        },
        async mounted() {

        },
        props: ['template', 'userAnswers'],
        methods: {
            changeHandler(e, qidx, aidx) {
                console.log(this.template.freeText[qidx].answers[aidx])
                this.userAnswers.answers.forEach((answer,index) => {

                    if(answer['question_id'] === this.template.freeText[qidx]['answers'][aidx]['question_id']){
                        this.userAnswers.answers.splice(index, 1);
                    }

                });
                this.userAnswers.answers.push({...this.template.freeText[qidx]['answers'][aidx]});
                console.log(this.userAnswers.answers)
                this.template.changeFlag = true;
            }
        }
    }
</script>

<style scoped>
    .q-input {
        background-color: transparent !important;
        border: 1px solid #39525C;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: scroll;
        overflow-x: hidden;
        min-height: 60px;
        max-height: 60px;
    }

    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .question-container:last-child {
        border-bottom: none;
    }
</style>